export const multiRupturePageInitialResponse = {
  textual_content_header: {
    ok: true,
    content: [
      {
        content_type: "Markdown",
        text: "Interrogate and view the ruptures in the inversion fault model (IFM) portion of the seismicity rate model (SRM). See the [Science Reports](Resources/ScienceReports) for more details on the SRM. See the [Technical Info page](TechInfo#rupture-explorer) for details on how branches of the logic tree were combined for this tool.\n\nSelect desired ruptures using the filters below. The details drawn on the map can be changed using MAP OPTIONS. Download the map, fault traces, fault surfaces, and MFD data using the download icon.",
      },
    ],
  },
  SOLVIS_locations_by_id: {
    edges: [],
  },
  SOLVIS_filter_rupture_sections: {
    model_id: "NSHM_v1.0.4",
    section_count: null,
    fault_surfaces: null,
    fault_traces: null,
    color_scale: null,
    mfd_histogram: null,
  },
  SOLVIS_filter_ruptures: null,
};
